import Vue from "vue";
import Router from "vue-router";
/* Layout */
import Layout from '../views/layout/index'
import government from './government'; // 政务
import logistics from './logistics'; // 智慧物流
import logisticsBigData from './logisticsBigData' // 数据分析
import industryCenter from "./industryCenter";  // 垂直产业
import supplyFinance from './supplyFinance';  // 供应链金融
import supplyChain from './supplyChain' // 应用云平台
import moreUnit from './moreUnit';
import newsCenter from './newsCenter'
import serviceCenter from './serviceCenter'
import helpCenter from './helpCenter'
import aboutUs from './aboutUs'
import supplyChainNew from './supplyChainNew'
import login from './login'
import waterage from './waterage'
import roadFreight from './roadFreight'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

export const constantRoutes = [
  ...login,
  ...waterage,
  ...roadFreight,
  {
    path: "/iframe",
    name: "Iframe",
    hidden: true,
    meta: { title: '留言建议', icon: 'el-icon-s-help' },
    component: () => import('@/views/iframe/index'),
    // children: [
    //   {
    //     path: '/iframe',
    //     component: () => import('@/views/iframe/index'),
    //   }
    // ]
  },
  {
    path: "/demand",
    name: "demand",
    hidden: true,
    meta: { title: '我有需求', icon: 'el-icon-s-help', href: process.env.NODE_ENV === 'testing' ? 'https://cs-info.hbgyl.com.cn/demandAdd' : 'https://info.hbgyl.com.cn/demandAdd', },
    component: () => import('@/views/hasGiveing/index'),
  },
  {
    path: "/gaving",
    name: "gaving",
    hidden: true,
    meta: { title: '我有供给', icon: 'el-icon-s-help', href: process.env.NODE_ENV === 'testing' ? 'https://cs-info.hbgyl.com.cn/supplyAdd' : 'https://info.hbgyl.com.cn/supplyAdd', },
    component: () => import('@/views/hasGiveing/index'),
  },
  {
    path: "/hallDetails",
    name: "hallDetails",
    hidden: true,
    meta: { title: '详情', icon: 'el-icon-s-help', href: process.env.NODE_ENV === 'testing' ? 'https://cs-info.hbgyl.com.cn/hallDetails' : 'https://info.hbgyl.com.cn/hallDetails', },
    component: () => import('@/views/hasGiveing/index'),
  },

  {
    path: "/websitestated",
    name: "websitestated",
    hidden: true,
    component: Layout,
    isChildren: false,
    meta: { title: '站点说明', icon: 'el-icon-s-help' },
    children: [
      {
        path: '/websitestated',
        component: () => import('@/views/websitestated/index'),
      }
    ]
  },
  {
    path: "/mesuggestions",
    name: "Mesuggestions",
    hidden: true,
    component: Layout,
    isChildren: false,
    meta: { title: '留言建议', icon: 'el-icon-s-help' },
    children: [
      {
        path: '/mesuggestions',
        component: () => import('@/views/mesuggestions/index'),
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: "/",
    name: "Main",
    component: Layout,
    redirect: '/index',
    meta: { title: '首页', icon: '' },
    mCode: "SYMK",
    children: [
      {
        path: '/index',
        component: () => import('@/views/home-v2/index'),
      }
    ]
  },

  {
    path: process.env.NODE_ENV === 'testing' ? "https://cs-login.hbgyl.com.cn/login?response_type=code&appId=46008f3b-36e4-4c0d-ae0b-2eab85517ceb&redirect_uri=https://cs-sj.hbgyl.com.cn/chain/login/oauth2/code/test" : "https://login.hbgyl.com.cn/login?response_type=code&appId=46008f3b-36e4-4c0d-ae0b-2eab85517ceb&redirect_uri=https://sj.hbgyl.com.cn/chain/login/oauth2/code/test",
    name: "大数据中心",
    target: true,
    open: true,
    mCode: "SJZX",
    // isChildren: false,
    // component: Layout,
    meta: { title: '大数据中心', icon: '' },
  },
  // ...supplyChain,
  ...newsCenter,
  ...serviceCenter,
  ...government,
  // ...logisticsBigData,
  // ...logistics,
  // ...industryCenter,
  // ...supplyFinance,
  ...supplyChainNew,
  ...helpCenter,
  ...aboutUs,
  ...moreUnit,
  // {
  //   path: "/about",
  //   name: "About",
  //   isChildren: false,
  //   component: Layout,
  //   hidden: process.env.NODE_ENV === 'testing'?false:true,
  //   mCode:"GYWM",
  //   meta: {title: '关于我们', icon: 'el-icon-s-help'},
  //   children: [
  //     {
  //       path: '/about',
  //       component: () => import('@/views/aboutUs/index'),
  //     }
  //   ]
  // },
  {
    path: "/table",
    name: "table",
    isChildren: false,
    hidden: true,
    component: Layout,
    meta: { title: 'table', icon: 'el-icon-s-help' },
    children: [
      {
        path: '/table',
        component: () => import('@/views/tables/index'),
      }
    ]
  },
]


const routes = [...constantRoutes, ...asyncRoutes]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})

const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/router/index.js